export const wait = seconds => new Promise((resolve) => setTimeout(resolve, seconds * 1000));

export const loadImage = url => new Promise((resolve, reject) => {
  const img = document.createElement('img');
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error(`Failed to load image ${url}`));
  img.src = url;
});